import { motion } from 'framer-motion';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { useImage } from 'global/cnr/contexts/useHelpers/useImage';
import { useContext, useEffect, useReducer } from 'react';
import { Icon } from 'semantic-ui-react';
import { ImageContext } from '../../cnr/contexts/ImageContext';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { UiItemContext } from '../../cnr/contexts/UiItemContext';
import { imageHandlers, imageInitialState, imageReducer } from '../../cnr/reducers/ImageReducer';
import { uniqueKey } from '../../common/keys';
import { gEnums } from '../../enums/globalEnums';
import { _animateTypes } from '../../motions/AnimateComponent';
import UiUpload from '../../pageItem/modification/dataManagement/UiUpload';
import { useElementOnScreen } from '../sem/visibleElements';

const UiImage = (props) => {

  const { showFullImage, cardDisplayType } = props

  // uiItemContext
  const uiItemContext = useContext(UiItemContext)
  const { item_state } = uiItemContext ?? {}
  const { viewItem, itemData, _imageOpts, _dataModificationOpts, viewItemStatus } = item_state ?? {}
  const { isViewItemSolo } = viewItemStatus ?? {}
  const { images } = _dataModificationOpts ?? {}
  const { allowAction } = images ?? {}
  const { images: images_viewItem, key: key_viewItem, dataSource } = viewItem ?? {}
  const { borderColor } = _imageOpts ?? {}
  const { dataCollectionName } = dataSource ?? {}
  const { email, _itemKey } = itemData ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { currentSettings_state, eventInfo_state, storage_state, paps_state, transition_state } = states
  const { viewKey } = paps_state ?? {}
  const { aps_global, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { projectOptions, storageOptions, appUserPermissions } = aps_global ?? {}
  const { useLazyImageLoading } = projectOptions ?? {}
  const { allowImageUpload } = appUserPermissions ?? {}
  const appUserAccess = useAppUserAccess()
  const { accessLevel, appUserSession, isAdminOrSuper } = appUserAccess ?? {}
  const { appUserSessionKey } = appUserSession ?? {}
  const pageIsAppUsers = viewKey === appUserSessionKey
  const _allowAction = (viewKey && (allowAction || allowImageUpload)) && (pageIsAppUsers || accessLevel >= gEnums.accessLevels.admin.value)

  const { storage_fns } = fns ?? {}

  const { transitions } = transition_state ?? {}
  const transition_image = transitions ? transitions[_animateTypes.image] : null

  const { useClientProfileImage } = aps_appUserSettings ?? {}

  const { appUserUrls } = eventInfo_state ?? {}
  const { galleries, appStorageUrlFiles } = storage_state ?? {}

  // eslint-disable-next-line 
  const [containerRef, isVisible] = useElementOnScreen({ root: null, rootMargin: '0px', threshold: 1.0 })

  let cn = 'card-image basic'
  // cn += ' is-' + imageSize
  if (useClientProfileImage && isAdminOrSuper) { cn += ' cpi' }

  const init_state = {
    _itemKey,
    allowAction: _allowAction,
    appStorageUrlFiles,
    appUserUrls,
    aps_appUserSettings,
    borderColor,
    cn,
    containerRef,
    dataCollectionName,
    galleries,
    images_viewItem,
    itemData,
    key_viewItem,
    showFullImage,
    storage_state,
    storageOptions,
    transition_image,
    useLazyImageLoading,
    viewItem,
    ...props
  }

  const { currentUrls } = useImage({ fileType: key_viewItem, itemData: props?.itemData, fullImage: false, _imageOpts })

  // image_state
  const [image_state, image_dispatch] = useReducer(imageReducer, init_state, imageInitialState);
  const image_handlers = imageHandlers(image_dispatch, image_state)
  const { _trueImageUrl, cardImageElement, showImageUpload, fullImageProps } = image_state ?? {}

  useEffect(() => {
    if (currentUrls) {
      image_handlers.handleSet_galleryImage({ urls: currentUrls }, _imageOpts)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentUrls]);


  useEffect(() => {
    if (fullImageProps && (isVisible || isViewItemSolo)) {
      image_handlers.handleImageVisible(_imageOpts)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [isVisible, fullImageProps, _trueImageUrl]);

  const altIcon = (showIcon) => showIcon && <Icon name='user' size='huge' color='blue' />

  const content = () => {
    const showAltImage = cardDisplayType === gEnums.cardDisplayTypes.profile || cardDisplayType === gEnums.cardDisplayTypes.profilePlus
    if (showImageUpload) {
      return <UiUpload origin={'UiImage'} handleCancel={image_handlers.handleShow_imageUpload} />
    } else {
      return <div className={cn} key={uniqueKey('crdi', _itemKey)} ref={containerRef}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          {cardImageElement?.element || altIcon(showAltImage)}
        </motion.div>
      </div>
    }
  }

  const imageProvider = () => <ImageContext.Provider value={{ image_state, image_handlers }}>
    {content()}
  </ImageContext.Provider>

  return imageProvider()

}

export default UiImage

export const addCardImage = (cardImage, image_viewItem, display) => {

  const { displayType, cardDisplayType } = display ?? {}
  const { imageLocation } = image_viewItem ?? {}

  if (cardImage && displayType === gEnums.displayTypes.card && cardDisplayType === gEnums.cardDisplayTypes.nameSectionOnly) {
    return cardImage
  } else {
    if (imageLocation && imageLocation.indexOf(imageLocation) >= 0) {
      return cardImage
    }
  }
}